import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { FlaskConical } from 'lucide-react';
import { DataSources } from './DataSources';

/**
 * Avis « version de test » (DISC-01). S'affiche au premier login, puis reste
 * rappelable depuis l'aide. Explique le statut, l'objet, et les sources de données.
 */
export function Disclaimer({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();
  return (
    <div
      className="fixed inset-0 z-30 grid place-items-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={t('disclaimer.title')}
      onClick={onClose}
    >
      <div
        className="max-h-[85vh] w-full max-w-lg space-y-3 overflow-y-auto rounded-2xl bg-surface p-6 shadow-xl ring-1 ring-border"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-amber-500/15 text-amber-500">
            <FlaskConical className="h-5 w-5" />
          </span>
          <h2 className="text-lg font-semibold">{t('disclaimer.title')}</h2>
        </div>

        <div className="md text-sm leading-relaxed">
          <ReactMarkdown>{t('disclaimer.intro')}</ReactMarkdown>
          <ReactMarkdown>{t('disclaimer.purpose')}</ReactMarkdown>
        </div>

        <div className="rounded-xl bg-surface-2/60 p-3">
          <p className="md mb-2 text-sm">
            <ReactMarkdown>{t('disclaimer.sourcesIntro')}</ReactMarkdown>
          </p>
          <DataSources />
        </div>

        <p className="text-xs text-muted">{t('disclaimer.recall')}</p>

        <div className="text-right">
          <button onClick={onClose} className="rounded-lg bg-accent px-4 py-1.5 text-sm font-medium text-accent-fg">
            {t('disclaimer.gotIt')}
          </button>
        </div>
      </div>
    </div>
  );
}
